import styled, { createGlobalStyle } from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'

export const GlobalStyle = createGlobalStyle`
  html {
    overflow: hidden; 
  }
`

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.04))
    drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  background-color: rgba(0, 0, 0, 0.25);
`

export const Content = styled.div<{ heightClass: HeightClass }>`
  position: absolute;
  background: white;
  padding: ${({ theme, heightClass }) =>
    theme.popup[heightClass]?.padding || '0px'};
  border-radius: 6px;
  max-width: 900px;

  @media (max-width: 576px) {
    max-width: calc(100% - 2rem);
  }
`
